export type MediaType = 'movie' | 'tv' | 'variety';

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  poster: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  description: string;
  heat: number;
  updatedAt: string;
}

export const mediaList: MediaItem[] = [
  {
    id: 'm1',
    title: '星际孤航',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20floating%20before%20a%20glowing%20deep%20blue%20nebula%2C%20dramatic%20rim%20lighting%2C%20moody%20dark%20space%20background%2C%20high%20detail%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-01&orientation=portrait',
    year: 2024,
    region: '美国',
    genres: ['科幻', '冒险'],
    rating: 9.1,
    duration: '2小时28分',
    director: '艾伦·维斯',
    actors: ['杰克·雷诺', '艾米·亚当斯', '汤姆·里德'],
    description: '一艘失联多年的深空探测船突然传回信号，宇航员林恩独自踏上追寻真相的旅程。她在浩瀚星海中发现了足以改写人类命运的谜团，也直面自己内心最深的孤独与执念。',
    heat: 9820,
    updatedAt: '2024-09-18',
  },
  {
    id: 'm2',
    title: '暗夜追凶',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20crime%20thriller%20movie%20poster%20with%20a%20silhouetted%20detective%20under%20rainy%20neon%20city%20lights%2C%20deep%20blue%20tones%20with%20orange%20highlights%2C%20moody%20atmospheric%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-02&orientation=portrait',
    year: 2024,
    region: '大陆',
    genres: ['犯罪', '悬疑'],
    rating: 8.4,
    duration: '2小时06分',
    director: '陈默',
    actors: ['张译川', '王砚', '刘琳'],
    description: '连续发生的离奇案件让整座城市陷入恐慌，刑警队长周焰在层层迷雾中追查真凶。当线索指向身边最信任的人时，他必须在正义与情义之间做出抉择。',
    heat: 9310,
    updatedAt: '2024-09-12',
  },
  {
    id: 'm3',
    title: '深海迷航',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20deep%20sea%20adventure%20movie%20poster%20of%20a%20submarine%20diving%20into%20a%20dark%20glowing%20trench%2C%20teal%20and%20blue%20underwater%20atmosphere%20with%20bioluminescent%20creatures%2C%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-03&orientation=portrait',
    year: 2023,
    region: '美国',
    genres: ['科幻', '惊悚'],
    rating: 7.9,
    duration: '1小时58分',
    director: '马克·莱恩',
    actors: ['伊桑·沃克', '索菲亚·罗斯'],
    description: '一支科考队深入马里亚纳海沟执行勘测任务，却遭遇未知生物的袭击。在万米之下的黑暗深海中，人类最原始的恐惧被彻底唤醒。',
    heat: 7620,
    updatedAt: '2023-11-02',
  },
  {
    id: 'm4',
    title: '长安月明',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20epic%20movie%20poster%20with%20a%20palace%20silhouette%20under%20a%20full%20moon%2C%20warm%20golden%20lantern%20glow%20against%20deep%20indigo%20night%2C%20elegant%20ink%20inspired%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-04&orientation=portrait',
    year: 2023,
    region: '大陆',
    genres: ['古装', '剧情'],
    rating: 8.6,
    duration: '2小时18分',
    director: '顾长风',
    actors: ['赵明轩', '白清云', '周季'],
    description: '盛世长安之下暗流涌动，一桩尘封多年的旧案牵动朝堂风云。书生沈砚为洗清父冤，一步步卷入权力旋涡，在明月与刀光之间寻回家国大义。',
    heat: 8450,
    updatedAt: '2023-08-21',
  },
  {
    id: 'm5',
    title: '你好，旧时光',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20warm%20nostalgic%20romance%20movie%20poster%20of%20two%20figures%20on%20a%20bicycle%20crossing%20a%20sunlit%20tree-lined%20lane%2C%20soft%20amber%20tones%20and%20gentle%20bokeh%2C%20tender%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-05&orientation=portrait',
    year: 2022,
    region: '大陆',
    genres: ['爱情', '剧情'],
    rating: 8.0,
    duration: '1小时52分',
    director: '林一苇',
    actors: ['苏念', '周少川'],
    description: '毕业多年后，曾经的少年伙伴在母校重逢。旧照片、旧信笺与不曾说出口的心事被一一打开，一段关于青春与错过的温柔故事缓缓展开。',
    heat: 6980,
    updatedAt: '2022-06-15',
  },
  {
    id: 'm6',
    title: '怒火重燃',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20action%20blockbuster%20poster%20with%20a%20heroic%20figure%20backlit%20by%20fiery%20orange%20explosions%20in%20a%20city%20street%2C%20dynamic%20high%20contrast%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-06&orientation=portrait',
    year: 2023,
    region: '香港',
    genres: ['动作', '犯罪'],
    rating: 7.6,
    duration: '2小时02分',
    director: '邓国豪',
    actors: ['韦天豪', '李蔓'],
    description: '被迫退隐的前特警在家人遭遇威胁后重出江湖。为了守护最后的底线，他孤身闯入庞大的地下势力网络，用拳头点燃沉寂已久的怒火。',
    heat: 7210,
    updatedAt: '2023-10-08',
  },
  {
    id: 'm7',
    title: '时间的尽头',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20philosophical%20sci-fi%20movie%20poster%20of%20a%20giant%20clock%20dissolving%20into%20a%20swirling%20galaxy%2C%20muted%20blue%20and%20amber%20gradients%2C%20dreamy%20surreal%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-07&orientation=portrait',
    year: 2024,
    region: '英国',
    genres: ['科幻', '剧情'],
    rating: 8.8,
    duration: '2小时14分',
    director: '奥利弗·格雷',
    actors: ['丹尼尔·福斯特', '克洛伊·贝拉米'],
    description: '一位物理学家发现时间正在以肉眼不可见的速度放慢。当世界逐渐走向静止，他必须在自己所剩不多的时间里，找到让一切重新流动的答案。',
    heat: 8760,
    updatedAt: '2024-07-30',
  },
  {
    id: 'm8',
    title: '山城迷雾',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20mystery%20movie%20poster%20of%20a%20foggy%20mountain%20town%20at%20dawn%20with%20a%20lone%20figure%20walking%20narrow%20stairs%2C%20cool%20blue%20mist%20with%20warm%20window%20lights%2C%20atmospheric%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-08&orientation=portrait',
    year: 2022,
    region: '大陆',
    genres: ['悬疑', '剧情'],
    rating: 7.7,
    duration: '1小时56分',
    director: '何嘉树',
    actors: ['吴子墨', '郑好'],
    description: '记者方远回到阔别已久的山城调查一桩旧案，浓雾之下小镇无人愿意开口。随着真相浮出水面，他发现每个人都在守护着自己的秘密。',
    heat: 6340,
    updatedAt: '2022-12-11',
  },
  {
    id: 'm9',
    title: '无声告白',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20quiet%20melancholic%20romance%20movie%20poster%20of%20a%20woman%20looking%20out%20a%20rainy%20window%2C%20soft%20muted%20blue%20and%20cream%20tones%2C%20gentle%20cinematic%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-09&orientation=portrait',
    year: 2021,
    region: '韩国',
    genres: ['剧情', '爱情'],
    rating: 8.2,
    duration: '1小时48分',
    director: '金秀贤',
    actors: ['朴恩静', '李承宇'],
    description: '一位失聪的花艺师与一位失去创作灵感的钢琴家相遇。他们用眼神与信纸交流，在最安静的时光里，说出了这一生最响亮的告白。',
    heat: 5870,
    updatedAt: '2021-09-25',
  },
  {
    id: 'm10',
    title: '疯狂星期五',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20playful%20comedy%20movie%20poster%20of%20two%20colorful%20characters%20swapping%20hats%20amid%20confetti%2C%20bright%20orange%20and%20yellow%20accents%20on%20light%20background%2C%20fun%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-10&orientation=portrait',
    year: 2023,
    region: '美国',
    genres: ['喜剧', '家庭'],
    rating: 7.3,
    duration: '1小时44分',
    director: '凯文·布鲁克斯',
    actors: ['艾米丽·卡特', '汤姆·哈迪森'],
    description: '工作狂妈妈和叛逆女儿在一次意外中互换了身体。手忙脚乱的一周里，她们第一次真正走进彼此的世界，也找回了久违的家庭温度。',
    heat: 5120,
    updatedAt: '2023-05-19',
  },
  {
    id: 'm11',
    title: '雪国车站',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20action%20poster%20of%20a%20futuristic%20train%20station%20buried%20in%20snow%2C%20cold%20blue%20tones%20with%20orange%20warning%20lights%2C%20crisp%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-11&orientation=portrait',
    year: 2024,
    region: '韩国',
    genres: ['科幻', '动作'],
    rating: 8.1,
    duration: '2小时00分',
    director: '车敏浩',
    actors: ['姜志勋', '徐雅琳'],
    description: '末世之后的最后一班列车停靠在冰封的车站。守卫士兵与幸存者必须在资源耗尽之前穿越雪原，而列车深处还藏着更大的阴谋。',
    heat: 7430,
    updatedAt: '2024-03-14',
  },
  {
    id: 'm12',
    title: '樱花之约',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20romantic%20Japanese%20movie%20poster%20of%20two%20people%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20with%20gentle%20sunset%20light%2C%20dreamy%20delicate%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-12&orientation=portrait',
    year: 2022,
    region: '日本',
    genres: ['爱情', '剧情'],
    rating: 7.8,
    duration: '1小时50分',
    director: '山本裕介',
    actors: ['佐藤美咲', '小林凉太'],
    description: '每年樱花盛开的季节，女孩都会回到那座小站等待。一个迟到多年的约定，在漫天花瓣中重新被记起，也在春天里迎来了迟来的重逢。',
    heat: 5610,
    updatedAt: '2022-04-02',
  },
  {
    id: 't1',
    title: '权力风云',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20political%20drama%20TV%20poster%20of%20an%20imposing%20capitol%20building%20silhouette%20at%20dusk%20with%20storm%20clouds%2C%20deep%20blue%20and%20gold%20tones%2C%20epic%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-13&orientation=portrait',
    year: 2024,
    region: '美国',
    genres: ['剧情', '历史'],
    rating: 9.3,
    duration: '第4季 · 全10集',
    director: '乔治·海耶斯',
    actors: ['罗伯特·金', '海伦·摩尔', '大卫·肖'],
    description: '在权力更迭的关键时刻，一场围绕改革法案的政治较量悄然展开。理想、野心与背叛交织，每个人都在为自己相信的未来押上全部筹码。',
    heat: 9950,
    updatedAt: '2024-09-20',
  },
  {
    id: 't2',
    title: '花开半夏',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20youth%20romance%20TV%20drama%20poster%20of%20students%20in%20a%20sunlit%20schoolyard%20with%20green%20leaves%2C%20fresh%20warm%20pastel%20tones%2C%20bright%20cheerful%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-14&orientation=portrait',
    year: 2023,
    region: '大陆',
    genres: ['爱情', '青春'],
    rating: 7.5,
    duration: '全32集',
    director: '周小夏',
    actors: ['夏晓', '陆行舟', '许安'],
    description: '转学生夏晓与学霸陆行舟从互看不顺眼到并肩前行。一整个夏天的汗水与心事，写成了关于成长、友谊与初恋的青春纪念册。',
    heat: 6820,
    updatedAt: '2023-07-16',
  },
  {
    id: 't3',
    title: '破晓行动',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20crime%20investigation%20TV%20poster%20of%20plainclothes%20officers%20at%20a%20night%20crime%20scene%20with%20police%20lights%2C%20cool%20blue%20tones%20with%20orange%20glow%2C%20tense%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-15&orientation=portrait',
    year: 2024,
    region: '香港',
    genres: ['犯罪', '悬疑'],
    rating: 8.5,
    duration: '全24集',
    director: '高志森',
    actors: ['林正峰', '何嘉欣', '郑力行'],
    description: '一支濒临解散的重案组在黎明前接下最后一案。随着调查深入，他们发现案件背后牵着一张盘踞多年的巨网，而真正的敌人或许就在身边。',
    heat: 8890,
    updatedAt: '2024-08-05',
  },
  {
    id: 't4',
    title: '江南烟雨',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20romance%20TV%20poster%20of%20a%20water%20town%20in%20misty%20rain%20with%20a%20woman%20in%20flowing%20robes%20on%20a%20bridge%2C%20soft%20blue%20and%20jade%20tones%2C%20elegant%20ink%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-16&orientation=portrait',
    year: 2022,
    region: '大陆',
    genres: ['古装', '爱情'],
    rating: 8.0,
    duration: '全40集',
    director: '温以宁',
    actors: ['沈清歌', '顾之行'],
    description: '江南水乡的绣娘与微服私访的世子在一次雨中邂逅。门第、家国与真心彼此拉扯，一段烟雨朦胧的深情人世，缓缓讲来。',
    heat: 7050,
    updatedAt: '2022-11-27',
  },
  {
    id: 't5',
    title: '命运交叉点',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20suspense%20TV%20series%20poster%20of%20overlapping%20city%20streets%20from%20above%20at%20night%2C%20cool%20blue%20and%20amber%20light%20trails%2C%20intricate%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-17&orientation=portrait',
    year: 2023,
    region: '英国',
    genres: ['悬疑', '剧情'],
    rating: 8.7,
    duration: '全8集',
    director: '亚瑟·布莱克',
    actors: ['奥利维亚·里德', '詹姆斯·科尔'],
    description: '八个陌生人的命运在一场深夜事故中悄然交汇。每个人都以为自己是偶然经过的旁观者，殊不知真相早已被写进彼此交错的过去。',
    heat: 8260,
    updatedAt: '2023-06-22',
  },
  {
    id: 't6',
    title: '东京食堂',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20cozy%20food%20drama%20TV%20poster%20of%20a%20small%20warm%20late-night%20eatery%20with%20hanging%20lanterns%2C%20warm%20amber%20glow%20against%20dark%20blue%20evening%2C%20tender%20digital%20painting%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-18&orientation=portrait',
    year: 2022,
    region: '日本',
    genres: ['剧情', '美食'],
    rating: 8.9,
    duration: '全12集',
    director: '中村和彦',
    actors: ['大野拓真', '田中由美'],
    description: '深夜街角的一间小食堂，只做几道家常菜。形形色色的客人带着各自的故事推门而入，一碗热汤、一碟小菜，安抚了无数疲惫的灵魂。',
    heat: 8640,
    updatedAt: '2022-10-30',
  },
  {
    id: 'v1',
    title: '奔跑吧银河',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20energetic%20reality%20show%20poster%20of%20a%20group%20of%20friends%20racing%20through%20a%20colorful%20obstacle%20course%2C%20vibrant%20orange%20and%20yellow%20accent%20blocks%2C%20playful%20bright%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-19&orientation=portrait',
    year: 2024,
    region: '大陆',
    genres: ['真人秀', '竞技'],
    rating: 8.0,
    duration: '第6季 · 每周五更新',
    director: '综艺制作组',
    actors: ['邓超然', 'Angel', '陈赫言'],
    description: '六位固定成员组成“银河小队”，走遍全国挑战各种脑洞大开的任务。爆笑互坑与热血团魂并存，每期都有意想不到的惊喜赛制。',
    heat: 8810,
    updatedAt: '2024-09-19',
  },
  {
    id: 'v2',
    title: '舞台之王',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20under%20dramatic%20spotlight%20on%20stage%2C%20deep%20blue%20background%20with%20orange%20stage%20lights%2C%20bold%20cinematic%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-20&orientation=portrait',
    year: 2023,
    region: '大陆',
    genres: ['音乐', '选秀'],
    rating: 8.2,
    duration: '全12期',
    director: '综艺制作组',
    actors: ['刘若英华', '周深逸'],
    description: '来自各地的实力唱将同台竞演，用声音一决高下。专业导师逐轮点评，现场观众实时投票，见证一位新晋舞台之王的诞生。',
    heat: 7790,
    updatedAt: '2023-09-09',
  },
  {
    id: 'v3',
    title: '密室大逃脱',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20escape%20room%20reality%20show%20poster%20of%20friends%20exploring%20a%20dark%20mysterious%20mansion%20hallway%20with%20flashlights%2C%20moody%20blue%20with%20orange%20spotlight%2C%20suspenseful%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-21&orientation=portrait',
    year: 2024,
    region: '大陆',
    genres: ['推理', '真人秀'],
    rating: 8.4,
    duration: '第5季 · 每周六更新',
    director: '综艺制作组',
    actors: ['杨幂', '魏大勋', '黄明昊'],
    description: '明星嘉宾组成解谜小队，进入精心搭建的主题密室寻找线索。烧脑推理、团队协作与惊吓尖叫齐飞，每期都是一场沉浸式冒险。',
    heat: 8150,
    updatedAt: '2024-09-14',
  },
  {
    id: 'v4',
    title: '全球美食家',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20food%20travel%20show%20poster%20of%20a%20chef%20tasting%20street%20food%20in%20a%20lively%20market%2C%20warm%20orange%20and%20earthy%20tones%2C%20appetizing%20vibrant%20digital%20illustration%2C%20vertical%20composition&width=500&height=750&seq=kp-poster-22&orientation=portrait',
    year: 2023,
    region: '韩国',
    genres: ['美食', '旅行'],
    rating: 8.6,
    duration: '全16期',
    director: '综艺制作组',
    actors: ['白钟元锡', '李瑞镇'],
    description: '资深美食家带着味蕾环游世界，走进市井小巷寻找最地道的味道。每一道菜背后，都藏着当地人最真实的生活与热情。',
    heat: 7380,
    updatedAt: '2023-12-18',
  },
];

export const heroSlides = [
  {
    id: 't1',
    title: '权力风云',
    subtitle: '第4季重磅回归 · 一场关于理想与野心的终极博弈',
    tagline: '本周热播',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20grand%20capitol%20hall%20at%20dusk%20with%20dramatic%20storm%20clouds%20and%20warm%20golden%20window%20light%2C%20deep%20blue%20atmosphere%2C%20epic%20moody%20digital%20painting%2C%20no%20text&width=1920&height=1080&seq=kp-hero-01&orientation=landscape',
  },
  {
    id: 'm1',
    title: '星际孤航',
    subtitle: '孤独穿越星海 · 追寻足以改写人类命运的答案',
    tagline: '院线新片',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20glowing%20blue%20nebula%20in%20deep%20space%2C%20dramatic%20rim%20light%2C%20moody%20atmospheric%20digital%20painting%2C%20no%20text&width=1920&height=1080&seq=kp-hero-02&orientation=landscape',
  },
  {
    id: 't6',
    title: '东京食堂',
    subtitle: '深夜街角的一碗热汤 · 治愈每一个疲惫的灵魂',
    tagline: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20cozy%20late-night%20Tokyo%20alley%20eatery%20with%20warm%20lantern%20glow%20against%20deep%20blue%20evening%2C%20rainy%20reflections%2C%20tender%20moody%20digital%20painting%2C%20no%20text&width=1920&height=1080&seq=kp-hero-03&orientation=landscape',
  },
  {
    id: 'm7',
    title: '时间的尽头',
    subtitle: '当世界逐渐静止 · 他还剩多少时间找到答案',
    tagline: '科幻巨制',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20giant%20clock%20face%20dissolving%20into%20a%20swirling%20star%20galaxy%2C%20muted%20blue%20and%20amber%20gradients%2C%20surreal%20dreamy%20digital%20painting%2C%20no%20text&width=1920&height=1080&seq=kp-hero-04&orientation=landscape',
  },
];

export const categoryInfo: Record<string, { name: string; slogan: string; description: string }> = {
  movie: {
    name: '电影频道',
    slogan: '最新大片一网打尽',
    description: '汇集院线新片、经典高分与热门类型电影，动作、科幻、爱情、悬疑一站看全。',
  },
  tv: {
    name: '电视剧频道',
    slogan: '热门好剧追不停',
    description: '内地剧、港剧、美剧、日韩剧应有尽有，口碑与话题之作持续更新。',
  },
  variety: {
    name: '综艺频道',
    slogan: '轻松解压乐翻天',
    description: '真人秀、音乐、悬疑推理与美食旅行节目，承包你的每一次下饭与放松时光。',
  },
};

export const genreOptions = ['动作', '爱情', '科幻', '喜剧', '悬疑', '剧情', '犯罪', '古装', '青春', '真人秀', '美食', '音乐'];
export const regionOptions = ['大陆', '美国', '香港', '日本', '韩国', '英国'];
export const yearOptions = ['2024', '2023', '2022', '2021'];
export const sortOptions = [
  { key: 'updated', label: '按更新时间' },
  { key: 'heat', label: '按热度' },
  { key: 'rating', label: '按评分' },
];

export const hotKeywords = ['科幻', '悬疑', '古装', '综艺', '高分电影'];